import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';

import { submitQuoteRequestSuccess } from '../../quoting/store/quoting/quoting.actions';
import { isPresidioMockQuoteSubmitted } from '../mock/presidio-mock-session';

/**
 * DEMO-ONLY: after mock quote submit, reload when session flag is set.
 * Removable with Presidio mock scaffolding — do not wire into production ICM builds.
 */
@Injectable()
export class PresidioMockQuoteEffects {
  constructor(private actions$: Actions) {}

  reloadAfterMockQuoteSubmit$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(submitQuoteRequestSuccess),
        tap(action => {
          if (typeof window === 'undefined') {
            return;
          }
          const id = action.payload.entity?.id;
          if (!id) {
            return;
          }
          const started = Date.now();
          const timer = window.setInterval(() => {
            if (isPresidioMockQuoteSubmitted(id)) {
              window.clearInterval(timer);
              window.location.reload();
            } else if (Date.now() - started > 8000) {
              window.clearInterval(timer);
            }
          }, 100);
        })
      ),
    { dispatch: false }
  );
}
